"use client"

import { useState, useEffect, useRef } from "react"
import Link from "next/link"

export default function ShopDropdown() {
  const [isOpen, setIsOpen] = useState(false)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)
  const dropdownRef = useRef<HTMLDivElement>(null)
  
  // Categories list - cleaned up names
  const categories = [
    { name: "Flower", href: "/shop/category/flower" },
    { name: "Vaporizers", href: "/shop/category/vaporizers" },
    { name: "Edibles", href: "/shop/category/edibles" },
    { name: "Concentrates", href: "/shop/category/concentrates" },
    { name: "Pre-rolls", href: "/shop/category/pre-rolls" },
    { name: "Tinctures", href: "/shop/category/tinctures" },
    { name: "Topicals", href: "/shop/category/topicals" },
    { name: "Accessories", href: "/shop/category/accessories" },
    { name: "Apparel", href: "/shop/category/apparel" },
  ]

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    setIsOpen(true)
  }

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setIsOpen(false)
    }, 150) // 150ms delay to prevent accidental closes
  }

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  return (
    <div 
      ref={dropdownRef}
      className={`absolute top-full left-1/2 transform -translate-x-1/2 mt-6 z-50 transition-opacity duration-200 ${
        isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
      }`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* Triangle pointer */}
      <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 w-4 h-4 bg-white rotate-45 border-t border-l border-gray-200"></div>
      
      {/* Dropdown content */}
      <div className="bg-white shadow-xl rounded-xl overflow-hidden border border-gray-100">
        <div className="w-[280px] p-4">
          {/* Categories Section - Single Column */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-3">
              <Link href="/shop" className="hover:text-primary_green">Shop Categories</Link>
            </h3>
            
            <div className="grid grid-cols-1 gap-1">
              {categories.map((category) => (
                <Link 
                  key={category.href} 
                  href={category.href}
                  className="flex items-center px-3 py-2 text-gray-700 hover:bg-gray-50 hover:text-primary_green rounded-lg transition-colors"
                  onClick={() => setIsOpen(false)}
                >
                  <span className="font-medium">{category.name}</span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
